import axiosBff from 'platform/axios';

export const uploadImage = (file: { content: string; fileName: string }) =>
    axiosBff.post<{ fullUrl: string }>('/sdo/api/images', file).then(response => response.data);
